import {useEffect} from 'react';
import {useInstance} from 'react-ioc';
import {useQuery} from '@apollo/client';
import {observer} from 'mobx-react-lite';

import {Store} from '../../model/store/Store';
import {currency} from '../../shared/graphql/__generated__/currency';
import {QUERY_CURRENCY} from '../../shared/graphql/me';

export const Currency = observer(() => {

    const {rate} = useInstance(Store)

    const query = useQuery<currency>(QUERY_CURRENCY, {pollInterval: 120000})

    useEffect(() => {
        if (rate.rates.EUR === 0 || rate.rates.USD === 0) {
            query.refetch()
        }
    }, [rate.rates.EUR, rate.rates.USD, query]);

    useEffect(() => {
        if (rate.rates.USD !== +query.data?.currency?.data?.attributes?.USD! ||
            rate.rates.EUR !== +query.data?.currency?.data?.attributes?.EUR!) {
            rate.setRate(
                +query.data?.currency?.data?.attributes?.MXN!,
                +query.data?.currency?.data?.attributes?.USD!,
                +query.data?.currency?.data?.attributes?.EUR!,
                +query.data?.currency?.data?.attributes?.KZT!,
                +query.data?.currency?.data?.attributes?.VND!,
            )
        }
    }, [rate, query.data?.currency?.data?.attributes?.KZT, query.data?.currency?.data?.attributes?.EUR, query.data?.currency?.data?.attributes?.MXN, query.data?.currency?.data?.attributes?.USD]);
    
    return null

})